"use client";

import React from "react";
import { Facebook, Instagram, Music, Loader, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Accueil</Link></li>
        <li data-index={1}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Tournois</Link></li>
        <li data-index={2}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Équipes</Link></li>
        <li data-index={3}><Link to="#" className="text-muted-foreground hover:text-primary transition-colors">Contact</Link></li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
function NewsletterForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-4 bg-primary/10 border border-primary/20 rounded-lg">
        <p className="text-primary font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <FormField control={control} name="email" rules={{
      required: "L'email est requis",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Email invalide"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Adresse email</FormLabel>
            <FormControl>
              <div className="relative">
                <input type="email" placeholder="Votre adresse email" className="flex h-12 w-full rounded-md border border-input bg-background/50 px-4 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-colors" {...field} />
                <Button type="submit" size="icon" disabled={isSubmitting} className="absolute right-1 top-1 h-10 w-10 rounded-md bg-primary text-primary-foreground hover:bg-primary/90">
                  {isSubmitting ? <Loader className="animate-spin size-4" /> : <Send className="size-4" />}
                  <span className="sr-only">S'inscrire</span>
                </Button>
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>} />
      {submitError && <p className="text-destructive text-sm mt-2">{submitError}</p>}
    </Form>;
}
export default function RejoignezLAventure() {
  return <footer id="rejoignez-laventure" className="bg-background text-foreground relative overflow-hidden pt-20 pb-10 px-4 md:px-8 lg:px-12">
      {}
      <div className="container mx-auto max-w-7xl relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-24 mb-16">
          
          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-2xl font-bold tracking-tight text-foreground uppercase">
              Navigation
            </h3>
            <Separator className="w-12 h-1 bg-primary rounded-full" />
            <MenuProvider menu_id="47">
              <FooterNavigation />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-2xl font-bold tracking-tight text-foreground uppercase">
              Suivez-nous
            </h3>
            <Separator className="w-12 h-1 bg-primary rounded-full" />
            <p className="text-muted-foreground">
              Rejoignez notre communauté de champions et ne manquez aucune action.
            </p>
            <div className="flex gap-4">
              {[{
              icon: Facebook,
              label: "Facebook",
              href: "#"
            }, {
              icon: Instagram,
              label: "Instagram",
              href: "#"
            }, {
              icon: Music,
              label: "TikTok",
              href: "#"
            }].map((social, i) => <Link key={i} data-index={i} to={social.href} className="flex items-center justify-center size-12 rounded-full bg-primary/10 text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 hover:scale-110 hover:-translate-y-1 shadow-sm hover:shadow-md" aria-label={social.label}>
                  <social.icon className="size-5" />
                </Link>)}
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-2xl font-bold tracking-tight text-foreground uppercase">
              Newsletter
            </h3>
            <Separator className="w-12 h-1 bg-primary rounded-full" />
            <p className="text-muted-foreground">
              Inscrivez-vous pour recevoir les dernières nouvelles, les dates des tournois et des offres exclusives.
            </p>
            <FormProvider formId="newsletter-footer" sectionName="footer" defaultValues={{
            email: ""
          }} submitText="S'inscrire" successMessage="Merci pour votre inscription !">
              <NewsletterForm />
            </FormProvider>
          </div>

        </div>

        <Separator className="bg-border/50 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Kickoff Events. Tous droits réservés.</p>
          <div className="flex gap-4">
            <Link to="#" className="hover:text-primary transition-colors">Mentions légales</Link>
            <Link to="#" className="hover:text-primary transition-colors">Politique de confidentialité</Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[1200px] opacity-[0.03] pointer-events-none z-0 flex justify-center items-end h-full overflow-hidden">
        <Link to="/" className="pointer-events-auto inline-block translate-y-1/4">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647492/img/kickoff_events_watermark_logo.png" alt="Kickoff Events" className="w-full h-auto object-contain" />
        </Link>
      </div>
    </footer>;
}